import {Navigate, Route, Routes} from "react-router-dom";
import {observer} from "mobx-react-lite";
import {AboutGame} from "../features/aboutGame/aboutGame";
import {Login} from "../features/auth/Login";
import {useApp} from "./useApp";
import {Settings} from "../features/settings/settings";
import {WaitingSocketConnection} from "@services/socket/WaitingSocketConnection";
import styles from "./App.module.scss";
import {WithRunningGame} from "@services/runningGame/withRunningGame";
import {lazy, Suspense} from "react";
import {Typography} from "@shared/ui/Typography/Typography";
import {AdminComponent} from "@shared/hoc/adminComponent";
import {NavigateObserver} from "@services/navigateObserver/NavigateObserver";
import {RouterObserver} from "@services/routerObserver/RouterObserver";

const HomeComponent = lazy(() => import("@pages//Home/Home"))
const GameComponent = lazy(() => import("@pages//Game/Game"))
const AdminPanel = lazy(() => import("@pages//AdminPanel/AdminPanel"))

const App = observer(() => {

    const {isAppInitialized} = useApp()

    if (!isAppInitialized) {
        return <div className={styles.root}>
            <Typography adaptiveFontSize={2} fontWeight={"bold"}>
                Загрузка...
            </Typography>
        </div>
    }

    return (
        <div className={styles.root}>
            <WaitingSocketConnection/>
            <NavigateObserver/>
            <RouterObserver/>

            <Routes>
                <Route path="/" element={
                    <WithRunningGame>
                        <Suspense fallback={
                            <div className={styles.root}>
                                <Typography adaptiveFontSize={2} fontWeight={"bold"}>
                                    Загрузка...
                                </Typography>
                            </div>
                        }>
                            <HomeComponent/>
                        </Suspense>
                    </WithRunningGame>
                }>
                    {/*<Route path="/" element={<Home/>}>*/}
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/registration/:key?" element={<Login/>}/>
                    <Route path="/aboutGame" element={<AboutGame/>}/>
                    <Route path="/settings" element={<Settings/>}/>
                </Route>
                <Route path="/game" element={
                    <WithRunningGame>
                        <Suspense fallback={
                            <div className={styles.root}>
                                <Typography adaptiveFontSize={2} fontWeight={"bold"}>
                                    Загрузка...
                                </Typography>
                            </div>
                        }>
                            <GameComponent/>
                        </Suspense>
                    </WithRunningGame>
                }/>
                <Route path="/adminPanel" element={
                    <AdminComponent>
                        <Suspense fallback={
                            <div className={styles.root}>
                                <Typography adaptiveFontSize={2} fontWeight={"bold"}>
                                    Загрузка...
                                </Typography>
                            </div>
                        }>
                            <AdminPanel/>
                        </Suspense>
                    </AdminComponent>
                }/>
                <Route path="*" element={<Navigate to="/" replace/>}/>
            </Routes>

        </div>
    )
});

export default App
